<template>
  <div class="tooltip">
    <slot></slot>
    <span v-if="text" :class="{
        'tooltip__text': true,
        'tooltip__left': isLeft,
        'tooltip__right': isRight
      }"
      v-html="text"
    ></span>
  </div>
</template>

<script>

const DIRECTIONS = {
  LEFT: 1,
  RIGHT: 2
}

export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    direction: {
      type: Number,
      default: 1
    }
  },
  computed: {
    isLeft () {
      return this.direction === DIRECTIONS.LEFT
    },
    isRight () {
      return this.direction === DIRECTIONS.RIGHT
    }
  }
}
</script>

<style lang="scss">
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip__left {
  top: -5px;
  bottom: auto;
  right: 100%;
}

.tooltip__right {
  top: -5px;
  bottom: auto;
  left: 100%;
}

.tooltip .tooltip__text {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  padding: 10px;
  border-radius: 6px;
  position: absolute;
  width: 250px;
  z-index: 100;
  white-space: normal;
}

.tooltip:hover .tooltip__text {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// Tooltip.vue?7c9a1298